/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Exporting_LabelInputs */



/**
* | output |
* | --- |
* | "Exporting:" |
*
* @param {Batch_Subtitle_Export_Exporting_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_exporting_label = /** @type {((inputs?: Batch_Subtitle_Export_Exporting_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Exporting_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportieren:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportador:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportador:")
	return /** @type {LocalizedString} */ ("Exporting:")
});